import React, {memo, useEffect} from 'react';
import styles from './styles.module.scss';
import useChats from "./slice";
import ChatsList from "@/app/features/chats/chat_list/widget";
import ChatPage from "@/app/features/chats/chat_page/widget";
import {useMediaQuery} from "@/app/utils/custom_function";
import Space from '@/app/components/space';
import CircularProgressIndicator from "@/app/components/circular_progress_indicator";
import {SearchParamsKey, useUrlParams} from "@/app/utils/use_search_params";

const ChatsPage = () => {
  const {getUrlParam} = useUrlParams();
  const isDesktop = useMediaQuery('(min-width:1024px)');
  const {state, search, goToMain, selectChat, goBack, sendMessage, addUserToChat, loadMoreChats} = useChats();

  const chatId = getUrlParam(SearchParamsKey.chat);

  useEffect(() => {
    if (isDesktop && state.selectedChat === undefined && state.chats && state.chats.length > 0 && !chatId) {
      selectChat(state.chats[0])
    }
  }, [isDesktop, state.chats]);

  if (state.chats === undefined) return <div className={styles.chats}>
    <CircularProgressIndicator isGreen/>

  </div>;
  return (
    <div className={styles.chats}>
      {!isDesktop ?
        state.selectedChat
          ? <ChatPage state={state} goBack={goBack} sendMessage={sendMessage} addUserToChat={addUserToChat}/>
          : <ChatsList search={search} state={state} goToMain={goToMain} onSelectChat={selectChat} loadMoreChats={loadMoreChats}/>
        : null}
      {isDesktop && <div className={styles.desktopWrapper}>
          <ChatsList search={search} state={state} goToMain={goToMain} onSelectChat={selectChat} loadMoreChats={loadMoreChats}/>
          <Space.W32/>
          <ChatPage state={state} goBack={goBack} sendMessage={sendMessage} addUserToChat={addUserToChat}/>
      </div>}
    </div>
  );
};

export default memo(ChatsPage);
